module.exports = __webpack_public_path__ + "static/price-online-aeb9c811cbfb1863c515411fdbaf2148.jpg";